import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../../services/apiService";
import {
  localDayEndToUtcDate,
  localDayStartToUtcDate,
} from "../../../services/dateUtils";
import { showSnackbar } from "../../snackbar/Snackbar.slice";

const PERIODIC_BILLING_REPORT_GENERATE = "periodicBillingReport/generateReport";

export const generateBillingReport = createAsyncThunk(
  PERIODIC_BILLING_REPORT_GENERATE,
  async (
    {
      merchant_id,
      start_date,
      end_date,
      status,
      token,
      onSuccessCallback = false,
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const formattedStartDate = localDayStartToUtcDate(start_date, "YYYY-MM-DD");
      const formattedEndDate = localDayEndToUtcDate(end_date, "YYYY-MM-DD");
      
      // Build URL with optional status parameter (only if status is provided and not empty)
      let url = `/invoices/report?merchant_id=${merchant_id}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
      if (status && status.trim() !== "") {
        url += `&status=${status}`;
      }
      
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await get(url, config);

      if (response?.data && Array.isArray(response.data) && response.data.length > 0) {
        dispatch(
          showSnackbar({
            message: "Report generated successfully!",
            severity: "success",
          })
        );

        if (onSuccessCallback) {
          onSuccessCallback();
        }

        return {
          data: response.data,
          total_records: response.total_records || response.data.length,
        };
      } else {
        dispatch(
          showSnackbar({
            message: "No invoices found for this date range",
            severity: "warning",
          })
        );
        return {
          data: [],
          total_records: 0,
        };
      }
    } catch (error) {
      console.error("Error generating billing report:", error);
      const errorMessage =
        error.response?.data?.detail ||
        error.message ||
        "Error generating report";
      dispatch(
        showSnackbar({
          message: errorMessage,
          severity: "error",
        })
      );
      return rejectWithValue({
        message: errorMessage,
      });
    }
  }
);

